<template>
    <ListTile @click="tileClicked()" class="elevation-0 user-activity__tile rounded-0 base-tile__border-none pa-0">


        <template v-slot:icon>
            <ProfilePicRoundByUrl :imageUrl="userActivity?.userProfilePicture" class="pointer profile-pic__user-activity">
            </ProfilePicRoundByUrl>
        </template>



        <template v-slot:details>
            <UserActivityTileDetails>
                <template v-slot:name>
                    <slot name="subtitle"></slot>
                </template>
                <template v-slot:description>
                    <slot name="title"></slot>
                </template>
            </UserActivityTileDetails>
        </template>



        <template v-slot:append-right>
            <slot name="append-item-right"></slot>
        </template>



    </ListTile>
</template>



<script lang="ts" setup>

import ListTile from '@/components/Tiles/List-Tile.vue';
import ProfilePicRoundByUrl from '@/components/Profile/Profile-Pic-Round-By-URL.vue';
import UserActivityTileDetails from '@/components/UserActivity/UserActivityTileElements/UserActivityTileDetails.vue';

const props = defineProps({
    userActivity: {
        type: Object,
        required: true,
    }
});

const emit = defineEmits(['click']);

const tileClicked = () => {
    emit('click');
};

</script>